var $42c2ade3746d2223$exports = {};
$42c2ade3746d2223$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};


export {$42c2ade3746d2223$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
